{
  "components": {
    "activity": {
      "content": {
        "checklist": {
          "title": "Checkliste bearbeiten"
        },
        "columnLayout": {
          "columnOperations": {
            "addColumn": "Spalte hinzufügen",
            "removeColumn": "Leere Spalte entfernen"
          }
        },
        "lAThematicArea": {
          "placeholder": "Themenbereich auswählen"
        },
        "storyboard": {
          "controls": "Aktionen",
          "reorder": "Verschieben",
          "storyboardDialogRemoveSection": {
            "deleteWarning": "Möchtest du diesen Abschnitt wirklich löschen?",
            "title": "Wirklich löschen?"
          }
        },
        "ysActivityCharacteristics": {
          "placeholder": "Erscheinungsformen auswählen"
        }
      },
      "dialog": {
        "dialogActivityEdit": {
          "title": "Aktivität bearbeiten"
        },
        "formScheduleEntryList": {
          "name": "Geplante Termine"
        }
      },
      "menuCardlessContentNode": {
        "deletingDisabled": "Muss leer sein zum Löschen"
      },
      "scheduleEntry": {
        "backToContents": "Zurück zum Bearbeiten des Inhalts",
        "changeLayout": "Layout ändern",
        "clipboardInfoDialog": {
          "allow": "Jetzt erlauben",
          "denied": "Du hast den Zugriff auf die Zwischenablage verweigert. Kopierte Aktivitäten können daher nicht eingefügt werden.",
          "description": "Damit du eine kopierte Aktivität einfügen kannst, musst du eCamp v3 erlauben, deine Zwischenablage zu lesen.",
          "granted": "Du kannst nun kopierte Aktivitäten einfügen.",
          "title": "Aktivität kopieren & einfügen"
        },
        "copyScheduleEntry": "Aktivität kopieren",
        "deleteWarning": "Möchtest du diese Aktivität wirklich löschen? Der komplette Inhalt dieser Aktivität wird gelöscht."
      },
      "togglePaperSize": {
        "switchToFullSize": "Zum Breitformat umschalten",
        "switchToPaperSize": "Zum Papierformat umschalten"
      }
    },
    "camp": {
      "campInvitations": {
        "title": "Einladen"
      },
      "campListItem": {
        "public": "Öffentlich"
      },
      "campMembers": {
        "title": "Mitglieder"
      },
      "footerSharedCamp": {
        "outsider": "Du arbeitest in diesem Lager nicht mit:",
        "outsiderDescription": "Du kannst keine Daten ändern, aber das Programm anschauen und kopieren.",
        "shared": "Lager ist öffentlich freigegeben:",
        "sharedDescription": "Fremde Personen können sämtliche Daten im Lager einsehen und kopieren."
      }
    },
    "campAdmin": {
      "campActivityProgressLabels": {
        "create": "Status erstellen",
        "deleteError": "Status konnte nicht gelöscht werden. Der Status wird noch verwendet.",
        "deleteWarning": "Möchtest du dieses Status wirklich löschen?",
        "exit": "Umsortieren beenden",
        "moveDown": "Nach unten",
        "moveUp": "Nach oben",
        "reorder": "Umsortieren",
        "title": "Block-Status"
      },
      "campAddress": {
        "title": "Lageradresse"
      },
      "campCategories": {
        "create": "Block-Kategorie erstellen",
        "pasteCategory": "Kopierte Kategorie einfügen",
        "title": "Block-Kategorien"
      },
      "campConditionalFields": {
        "course": {
          "title": "Kurse"
        },
        "title": "Einstellungen für J+S",
        "ysCamp": {
          "title": "Lager"
        }
      },
      "campDangerZone": {
        "deleteCamp": {
          "description": "Nachdem ein Lager gelöscht ist, gibt es kein zurück mehr. Bitte fahre nur fort, wenn du sicher bist.",
          "explanation": "Diese Aktion kann nicht rückgängig gemacht werden. Dadurch wird das Lager \"{campTitle}\" inklusive allen Aktivitäten, Materiallisten und Verantwortungszuweisungen dauerhaft gelöscht.",
          "label": "Bitte gib zur Bestätigung \"{campTitle}\" ein.",
          "title": "Lager löschen"
        },
        "title": "Gefahrenzone"
      },
      "campHitobitoSync": {
        "linked": "Dieses Lager ist mit {provider} verknüpft.",
        "sync": "Synchronisieren",
        "title": "Lagerinfos synchronisieren"
      },
      "campMaterialLists": {
        "createMaterialList": "Materialliste erstellen",
        "title": "Materiallisten"
      },
      "campPeriods": {
        "createPeriod": "Lagerabschnitt erstellen",
        "title": "Lagerabschnitt | Lagerabschnitte"
      },
      "campPeriodsListItem": {
        "changePeriodDescription": "Bezeichnung ändern",
        "deleteWarning": "Möchtest du diesen Lagerabschnitt wirklich löschen?",
        "lastPeriodNotDeletable": "Der letzte Lagerabschnitt kann nicht gelöscht werden.",
        "movePeriod": "Lagerabschnitt verschieben",
        "periodChangeEnd": "Am Ende Tage hinzufügen/entfernen",
        "periodChangeStart": "Zu Begin Tage hinzufügen/entfernen"
      },
      "campSettings": {
        "title": "Beschreibung"
      },
      "campSharingSettings": {
        "activate": "Freigabe aktivieren",
        "deactivate": "Freigabe deaktivieren",
        "implications": "Wenn du die Freigabe aktivierst, dann können fremde Personen das Programm, das Team, die Materiallisten und Verantwortlichkeiten und alles andere in diesem Lager ansehen und kopieren. Nur Personen im Team können Daten ändern.",
        "notShared": {
          "description": ": Nur Personen im Team können das Programm und die Daten in diesem Lager ansehen.",
          "title": "Freigabe ist nicht aktiviert"
        },
        "publicCampUrl": "Sharing-Link zum Lager",
        "shared": {
          "description": ": Fremde Personen können das Programm, das Team, die Materiallisten und Verantwortlichkeiten und alles andere in diesem Lager ansehen und kopieren. Nur Personen im Team können Daten ändern.",
          "title": "Lager ist öffentlich freigegeben"
        },
        "sharedSince": "Am {sharedSince} von {sharedBy}",
        "title": "Lager teilen"
      },
      "createCampPeriods": {
        "add": "Weiteren Lagerabschnitt hinzufügen"
      },
      "dialogActivityProgressLabelCreate": {
        "title": "Block-Status erstellen"
      },
      "dialogActivityProgressLabelEdit": {
        "title": "Status bearbeiten"
      },
      "dialogCategoryCreate": {
        "clearClipboard": "Zwischenablage leeren",
        "clipboard": "Zwischenablage",
        "clipboardInfoDialog": {
          "allow": "Jetzt erlauben",
          "denied": "Du hast den Zugriff auf die Zwischenablage verweigert. Kopierte Kategorien können daher nicht eingefügt werden.",
          "description": "Damit du eine kopierte Kategorie einfügen kannst, musst du eCamp v3 erlauben, deine Zwischenablage zu lesen.",
          "granted": "Du kannst nun kopierte Kategorien einfügen.",
          "title": "Kategorie kopieren & einfügen"
        },
        "copyCategoryOrActivity": "Kategorie oder Aktivität kopieren",
        "copyContent": "Inhalt kopieren",
        "copyPasteCategory": "Kategorie kopieren & einfügen",
        "copySourceInfo": "Hier kannst du die URL einer Block-Kategorie oder einer Aktivität einfügen, um dessen Inhalte zu kopieren.",
        "pasteCategory": "Kopierte Kategorie oder Aktivität einfügen",
        "title": "Block-Kategorie erstellen"
      },
      "dialogMaterialListCreate": {
        "title": "Materialliste erstellen"
      },
      "dialogMaterialListEdit": {
        "deleteError": "Materialliste konnte nicht gelöscht werden. Überprüfe vor dem Löschen, dass die Liste leer ist.",
        "title": "Materialliste bearbeiten"
      },
      "dialogPeriodCreate": {
        "title": "Lagerabschnitt erstellen"
      },
      "dialogPeriodDateEdit": {
        "movePeriod": "Lagerabschnitt verschieben",
        "periodChangeEnd": "Am Ende vom Lagerabschnitt Tage hinzufügen / entfernen",
        "periodChangeStart": "Am Anfang vom Lagerabschnitt Tage hinzufügen / entfernen",
        "periodDuration": "Anzahl Tage"
      },
      "dialogPeriodEdit": {
        "moveScheduleEntries": "Aktivitäten verschieben"
      },
      "errorExistingActivitiesList": {
        "description": "Kann nicht gelöscht werden. Wird noch von folgenden Aktivitäten verwendet:"
      }
    },
    "campCreate": {
      "campCreate": {
        "steps": {
          "configurate": "Konfigurieren",
          "infos": "Infos",
          "template": "Vorlage"
        }
      },
      "campCreateStep1": {
        "submitTooltip": "Bitte fülle alle Pflichtfelder aus.",
        "titlePlaceholder": "Klassenlager 2024 5. Klasse"
      },
      "campCreateStep2": {
        "category": "Block-Kategorien",
        "checklistItemCount": "Keine Einträge | Ein Eintrag | {count} Einträge",
        "checklists": "Checklisten",
        "clipboardInfoDialog": {
          "allow": "Jetzt erlauben",
          "denied": "Du hast den Zugriff auf die Zwischenablage verweigert. Bitte füge den Link zum Vorlage-Lager stattdessen von Hand ein.",
          "description": "Damit du die Einstellungen eines kopierten Lagers einfügen kannst, musst du eCamp v3 erlauben, deine Zwischenablage zu lesen.",
          "granted": "Du kannst nun kopierte Lagereinstellungen einfügen.",
          "title": "Lagereinstellungen kopieren & einfügen"
        },
        "create": "Lager erstellen",
        "materialLists": "Materiallisten",
        "noContent": "Keine Inhalte",
        "noPrototype": "Keine Vorlage",
        "noPrototypeAlert": {
          "description": "Du musst alle Einstellungen manuell vornehmen. Es sind keine Blockvorlagen & Layouts vorhanden. Dies ist nur für erfahrene Nutzende geeignet.",
          "title": "Achtung: Du hast \"Keine Vorlage\" ausgewählt."
        },
        "otherPrototype": "Einstellungen von einem anderen Lager kopieren…",
        "pasteCamp": "Kopierte Lagereinstellungen einfügen",
        "preview": "Vorschau der Lagervorlage",
        "progressLabels": "Blockstatus",
        "prototypeCampUrl": "Link zum gewünschten Vorlage-Lager",
        "prototypeHint": "Kopiere Kategorien, Blockvorlagen, Blockstatus, Material- und Checklisten von einer Lagervorlage",
        "prototypeHintEmpty": "Keine Kategorien, Blockvorlagen, Blockstatus, Material- und Checklisten aus einer Lagervorlage kopieren",
        "prototypeHintOther": "Kopiere Kategorien, Blockvorlagen, Blockstatus, unpersönliche Material- und Checklisten von diesem anderen Lager. Es werden keine Aktivitäten kopiert.",
        "prototypeHintSelected": "Kopiere Kategorien, Blockvorlagen, Blockstatus und Materiallisten von dieser Lagervorlage",
        "submitTooltipPrototype": "Du musst noch auswählen, ob und welche Lagervorlage du verwenden möchtest."
      }
    },
    "campHitobitoSync": {
      "hitobitoSyncDiffTable": {
        "current": "Aktuell (eCamp)",
        "field": "Feld",
        "updated": "Neu ({provider})"
      }
    },
    "campImport": {
      "campImport": {
        "steps": {
          "event": "Lager",
          "template": "Vorlage"
        }
      },
      "campImportStep1": {
        "alreadyImported": "Bereits importiert",
        "event": "Lager",
        "noEvents": "Kein Lager gefunden",
        "search": "Lager suchen",
        "submitTooltip": "Bitte wähle ein Lager aus."
      },
      "errors": {
        "alreadyExists": "Für dieses {provider}-Lager existiert bereits ein Lager im eCamp.",
        "generic": "Die Lager konnten nicht geladen werden. Bitte versuche es später erneut.",
        "noAccess": "Du hast keinen Zugriff auf dieses Lager.",
        "notFound": "Dieses Lager wurde nicht gefunden."
      },
      "hitobitoEventSummary": {
        "field": "Feld",
        "fields": {
          "address": "Adresse",
          "end": "Ende",
          "motto": "Motto",
          "start": "Start",
          "title": "Titel"
        },
        "period": "Lagerabschnitt {number}",
        "title": "Lagerinfos",
        "value": "Wert"
      }
    },
    "category": {
      "categoryTemplate": {
        "contents": "Inhalte",
        "createLayoutHelp": "Hier kannst du die Vorlage für neue {categoryShort}-Blöcke definieren.{br}Blockinhalt & Layout bereits erstellter {categoryShort}-Blöcke, werden nicht angepasst.",
        "layout": "Layout",
        "noTemplate": "Keine Vorlage"
      }
    },
    "checklist": {
      "checklistCreate": {
        "title": "Checkliste erstellen"
      },
      "checklistDetail": {
        "deleteError": "Checkliste konnte nicht gelöscht werden. Überprüfe vor dem Löschen, dass die Checkliste nicht mehr in Aktivitäten verwendet wird.",
        "deleteWarning": "Möchtest du diese Checkliste wirklich löschen? Der komplette Inhalt dieser Checkliste wird gelöscht."
      },
      "checklistItemCreate": {
        "add": "Checklisten-Eintrag erstellen",
        "title": "Checklisten-Eintrag hinzufügen"
      },
      "checklistItemEdit": {
        "delete": "Möchtest du diesen Eintrag wirklich löschen?",
        "title": "Checklisten-Eintrag bearbeiten"
      },
      "sortableChecklist": {
        "add": "Neuer Eintrag in \"{parent}\""
      }
    },
    "collaborator": {
      "collaboratorBulkCreate": {
        "validationFailed": "Bereits im Team oder ungültige E-Mail-Adresse:",
        "emailsHint": "Eine E-Mail-Adresse pro Zeile oder durch Kommas getrennt eingeben",
        "emailsLabel": "E-Mail-Adressen",
        "failedEmails": "Einladung fehlgeschlagen: {emails}",
        "invite": "Einladungen verschicken",
        "inviteCta": "Mehrere Personen einladen",
        "successCount": "{count} Einladung(en) verschickt",
        "title": "Mehrere Personen einladen"
      },
      "collaboratorCreate": {
        "emailLabel": "E-Mail-Adresse",
        "invite": "Einladung verschicken",
        "inviteCta": "Ins Team einladen",
        "noResults": "Keine passenden Personen gefunden. Du kannst jede Person über ihre E-Mail-Adresse einladen.",
        "searchHint": "Suche Personen aus gemeinsamen Lagern nach Name, Pfadiname oder E-Mail, oder gib eine neue E-Mail-Adresse ein.",
        "title": "Person einladen"
      },
      "collaboratorEdit": {
        "cannotRemoveLastManager": "Du kannst die letzte Person mit administrativen Rechten nicht deaktivieren",
        "deactivate": "Deaktivieren",
        "delete": "Möchtest du die Person '{name}' wirklich entfernen?",
        "inviteAgain": "Erneut einladen",
        "leaveCamp": "Lager verlassen",
        "resendEmail": "E-Mail erneut senden",
        "resentEmail": "Einladung gesendet",
        "title": "{user} bearbeiten"
      },
      "collaboratorForm": {
        "overrideAvatar": "Avatar für dieses Lager überschreiben",
        "roleHint": "Jedes Lager benötigt mindestens eine Person mit Administrationsrechten."
      },
      "collaboratorHitobitoInvite": {
        "inviteCta": "Aus {provider} einladen"
      },
      "promptCollaboratorDeactivate": {
        "deactivate": "Deaktivieren",
        "leaveCamp": "Lager verlassen",
        "warningText": "Möchtest du '{name}' wirklich deaktivieren?",
        "warningTextLeaveCamp": "Möchtest du das Lager '{camp}' wirklich verlassen?"
      }
    },
    "comments": {
      "commentCard": {
        "campComment": "Ganzes Lager",
        "deleteDisabledReplies": "Kommentare mit Antworten von anderen Personen können nicht gelöscht werden.",
        "deleteWarning": "Möchtest du deinen Kommentar wirklich löschen?",
        "deleteWithRepliesWarning": "Möchtest du deinen Kommentar zusammen mit deinen Antworten darauf wirklich löschen?",
        "deleted": "(gelöscht)",
        "deletedAuthor": "Gelöschte Person"
      },
      "commentComposer": {
        "placeholder": "Kommentar schreiben",
        "replyPlaceholder": "Antwort schreiben"
      },
      "commentThread": {
        "reopen": "Wieder öffnen",
        "reply": "Antworten",
        "resolve": "Erledigt",
        "resolved": "Erledigt",
        "resolvedBy": "Erledigt von {user}",
        "resolvedToast": "Kommentar erledigt. Erledigte Kommentare werden nur unter \"Alle\" angezeigt.",
        "showAll": "Alle anzeigen"
      },
      "commentTime": {
        "today": "Heute, {time}",
        "yesterday": "Gestern, {time}"
      },
      "commentsList": {
        "empty": "Noch keine Kommentare.",
        "noOpenComments": "Keine offenen Kommentare. Wechsle zu \"Alle\", um die erledigten zu sehen."
      },
      "commentsPanel": {
        "activityCommentsElsewhere": "Ein weiterer offener Kommentar befindet sich bei einer Aktivität. | {count} weitere offene Kommentare befinden sich bei einzelnen Aktivitäten.",
        "all": "Alle",
        "commentsOnThisActivity": "Kommentare zu dieser Aktivität",
        "open": "Offen",
        "title": "Kommentare"
      },
      "commentsToggleButton": {
        "hide": "Kommentare ausblenden",
        "show": "Kommentare anzeigen | Einen Kommentar anzeigen | {count} Kommentare anzeigen"
      }
    },
    "dashboard": {
      "activityRow": {
        "comments": "Keine Kommentare | Einen Kommentar anzeigen | {count} Kommentare anzeigen"
      },
      "selectFilter": {
        "clear": "Zurücksetzen"
      }
    },
    "dialog": {
      "dialogEntityDelete": {
        "title": "Wirklich löschen?"
      }
    },
    "form": {
      "base": {
        "eColorField": {
          "parseError": "Bitte gültige Farbe eingeben."
        },
        "eColorPicker": {
          "closePicker": "Dialog schliessen",
          "openPicker": "Dialog öffnen, um eine Farbe für {label} zu wählen"
        },
        "eDatePicker": {
          "invalidFormat": "Ungültiges Format, bitte gib das Datum im Format DD.MM.YYYY ein",
          "openPicker": "Dialog öffnen, um ein Datum für {label} zu wählen"
        },
        "eTimeField": {
          "invalidFormat": "Ungültiges Format, bitte gib die Zeit im Format HH:MM ein"
        },
        "eTimePicker": {
          "invalidFormat": "Ungültiges Format, bitte gib die Zeit im Format HH:MM ein",
          "openPicker": "Dialog öffnen, um eine Zeit für {label} zu wählen"
        }
      }
    },
    "generic": {
      "lockButton": {
        "clickToLock": "Klicken um zu sperren",
        "clickToUnlock": "Klicken um zu entsperren",
        "guestsCannotEdit": "Gäste können nicht bearbeiten"
      }
    },
    "layout": {
      "authContainer": {
        "photoCredits": "Foto von Markus Rohner / Lotos"
      }
    },
    "material": {
      "dialogMaterialItemCreate": {
        "title": "Materialeintrag erstellen"
      },
      "dialogMaterialItemEdit": {
        "title": "Materialeintrag bearbeiten"
      },
      "materialCreateItem": {
        "campSettingsButton": "Einstellungen",
        "noMaterialListAvailable": "Für dieses Lager sind noch keine Materiallisten erfasst. Du kannst diese unter 'Admin' erfassen."
      },
      "materialListSelect": {
        "createNew": "Neu erstellen",
        "noListsFound": "Keine Liste gefunden"
      },
      "materialLists": {
        "materialsCount": "Keine Einträge | 1 Eintrag | {count} Einträge",
        "overview": "Gesamtübersicht",
        "unassigned": "Nicht zugewiesen"
      },
      "materialTable": {
        "addNewItem": "Eintrag hinzufügen",
        "noItems": "Keine Einträge gefunden",
        "periodOnly": "Filter: Lagerabschnitt",
        "reference": "Aktivität / Abschnitt"
      },
      "useMaterialViewHelper": {
        "detail": "Materialliste",
        "overview": "Gesamtübersicht"
      }
    },
    "navigation": {
      "userMeta": {
        "admin": "Admin",
        "invitations": "Einladungen",
        "logOut": "Ausloggen",
        "myCamps": "Meine Lager",
        "profile": "Profil"
      }
    },
    "personalInvitations": {
      "dialogPersonalInvitationReject": {
        "rejectInvitation": "Einladung ablehnen",
        "warningText": "Möchtest du die Einladung zum Lager \"{campTitle}\" wirklich ablehnen?"
      },
      "personalInvitations": {
        "accept": "Akzeptieren",
        "noOpenInvitations": "Keine offene Einladungen. Wurde die Einladung an eine andere Adresse als \"{email}\" versendet?",
        "reject": "Ablehnen"
      }
    },
    "print": {
      "config": {
        "activityConfig": {
          "activity": "Aktivität"
        },
        "dialogScheduleEntryFilter": {
          "filterActive": "Filter: {filtered} von {total} Aktivitäten",
          "filterActivities": "{total} Aktivitäten filtern",
          "resultCount": "Resultat: {filtered} von {total} Aktivitäten",
          "title": "Aktivitäten filtern"
        },
        "picassoConfig": {
          "orientation": "Seitenlayout",
          "landscape": "Querformat",
          "periods": "Lagerabschnitt(e)",
          "portrait": "Hochformat"
        },
        "programConfig": {
          "dayOverview": "Tagesübersicht"
        }
      },
      "documents": {
        "campPrint": {
          "filename": {
            "activitiesOnly": "Aktivitäten {camp}",
            "picassoOnly": "Grobprogramm {camp}"
          }
        }
      },
      "localPdfDownloadButton": {
        "error": "Etwas hat nicht geklappt. Probiere es nochmals, oder lade die Seite neu."
      },
      "printClient": {
        "downloadClientPdfButton": {
          "label": "PDF herunterladen (Layout #2)"
        },
        "downloadClientPdfListItem": {
          "label": "PDF herunterladen (Layout #2)"
        },
        "generatePdfMixin": {
          "error": "Etwas hat nicht geklappt. Probiere es nochmals, oder lade die Seite neu.",
          "progress": {
            "loadingData": "Lade die aktuellsten Daten des Lagers…",
            "setupTranslationsAndFonts": "Lade Schriftarten und Texte…",
            "assembleContent": "Stelle {type} zusammen ({content} von {totalContents})…",
            "layoutDocument": "Berechne Dokument-Layout…",
            "layoutPage": "Berechne Layout von Seite {page}…",
            "renderingPdfPage": "Rendere PDF-Seite {page} von {totalPages}…",
            "downloadingPdf": "Lade die PDF-Datei herunter…",
            "done": "Fertig",
            "failed": "Abgebrochen"
          }
        },
        "printPreviewClient": {
          "previewError": "Etwas hat nicht geklappt. Probiere es nochmals mit anderen Druckeinstellungen, oder lade die Seite neu.",
          "previewIframeTitle": "Druckvorschau"
        }
      },
      "printConfigurator": {
        "add": "Inhalt hinzufügen",
        "config": {
          "Activity": "Einzelne Aktivität",
          "ActivityList": "Aktivitätenliste (Kurse)",
          "Cover": "Titelseite",
          "Picasso": "Grobprogramm",
          "Program": "Detailprogramm",
          "SafetyConsiderations": "Sicherheits­überlegungen",
          "Story": "Geschichte",
          "Toc": "Inhaltsverzeichnis"
        },
        "options": "Einstellungen",
        "pageNumbers": "Seitenzahlen",
        "fontSize": "Schriftgrösse",
        "fontSizes": {
          "A3": "Kleinere Schrift (optimiert für A4 oder A3)",
          "A4": "Normale Schrift (optimiert für A4 oder A5)",
          "A5": "Grössere Schrift (optimiert für A6)"
        }
      },
      "printNuxt": {
        "downloadNuxtPdfButton": {
          "label": "PDF herunterladen (Layout #1)"
        },
        "downloadNuxtPdfListItem": {
          "label": "PDF herunterladen (Layout #1)"
        },
        "generatePdfMixin": {
          "error": "Etwas hat nicht geklappt. Probiere es nochmals, oder lade die Seite neu.",
          "queueFull": "Alle unsere PDF-Drucker sind im Moment beschäftigt. Bitte versuche es später nochmals."
        },
        "printPreviewNuxt": {
          "openPreview": "Vorschau in neuem Fenster öffnen",
          "previewError": "Etwas hat nicht geklappt. Probiere es nochmals mit anderen Druckeinstellungen, oder lade die Seite neu.",
          "previewIframeTitle": "Druckvorschau"
        }
      }
    },
    "program": {
      "dialogActivityCreate": {
        "clearClipboard": "Zwischenablage leeren",
        "clipboard": "Zwischenablage",
        "clipboardInfoDialog": {
          "allow": "Jetzt erlauben",
          "denied": "Du hast den Zugriff auf die Zwischenablage verweigert. Kopierte Aktivitäten können daher nicht eingefügt werden.",
          "description": "Damit du eine kopierte Aktivität einfügen kannst, musst du eCamp v3 erlauben, deine Zwischenablage zu lesen.",
          "granted": "Du kannst nun kopierte Aktivitäten einfügen.",
          "title": "Aktivität kopieren & einfügen"
        },
        "copyActivity": "Aktivität kopieren",
        "copyActivityContent": "Inhalt von Aktivität kopieren",
        "copyPasteActivity": "Aktivität kopieren & einfügen",
        "copySourceInfo": "Hier kannst du die URL einer Aktivität einfügen, um dessen Inhalte zu kopieren.",
        "pasteActivity": "Kopierte Aktivität einfügen"
      },
      "formScheduleEntryItem": {
        "end": "Ende",
        "start": "Start"
      },
      "formScheduleEntryList": {
        "name": "Geplante Termine"
      },
      "periodSwitcher": {
        "title": "Lagerabschnitt wählen"
      },
      "picasso": {
        "picasso": {
          "datetime": {
            "fullDate": "dd, DD. MMMM YYYY",
            "smallDate": "dd, D.MM. | dd, D. MMM | dd, D. MMM YY"
          }
        },
        "picassoEntry": {
          "clipboardInfoDialog": {
            "allow": "Jetzt erlauben",
            "denied": "Du hast den Zugriff auf die Zwischenablage verweigert. Kopierte Aktivitäten können daher nicht eingefügt werden.",
            "description": "Damit du eine kopierte Aktivität einfügen kannst, musst du eCamp v3 erlauben, deine Zwischenablage zu lesen.",
            "granted": "Du kannst nun kopierte Aktivitäten einfügen.",
            "title": "Aktivität kopieren & einfügen"
          },
          "location": "Ort:",
          "responsible": "Verantwortlich: "
        }
      },
      "scheduleEntryFilters": {
        "category": "Kategorie",
        "clearFilters": "Filter entfernen",
        "day": "Datum",
        "dayLabel": "Tag {dayNumber} ({date})",
        "allMyActivities": "Alle meine Aktivitäten",
        "onlyMyActivities": "Nur meine Aktivitäten",
        "period": "Lagerabschnitt",
        "progressLabel": "Status",
        "progressLabelNone": "Kein Status",
        "responsible": "Verantwortlich",
        "responsibleNone": "Keine Verantwortlichen"
      }
    },
    "prompt": {
      "promptEntityDelete": {
        "title": "Wirklich löschen?"
      }
    },
    "story": {
      "storyDay": {
        "noStory": "Die Blöcke an diesem Tag enthalten keinen roten Faden."
      }
    },
    "toast": {
      "toasts": {
        "multiLineToast": {
          "generalError": "Ein Fehler ist aufgetreten."
        }
      }
    },
    "user": {
      "dialogChangeMail": {
        "error": "Leider ist ein Fehler aufgetreten.",
        "message": "Zur Verifikation schicken wir dir eine Mail.",
        "success": "Bevor du die neue E-Mail-Adresse verwenden kannst, musst du diese verifizieren. Prüfe jetzt deine Mailbox.",
        "title": "E-Mail-Adresse ändern"
      },
      "dialogChangeMailRunning": {
        "error": "Leider ist ein Fehler aufgetreten.",
        "message": "E-Mail-Adresse wird geändert...",
        "success": "E-Mail-Adresse erfolgreich geändert.",
        "title": "E-Mail-Adresse wird geändert"
      },
      "dialogChangePassword": {
        "title": "Passwort ändern",
        "currentPassword": "Aktuelles Passwort",
        "newPassword": "Neues Passwort",
        "newPasswordConfirmation": "Neues Passwort bestätigen",
        "success": "Dein Passwort wurde erfolgreich geändert.",
        "error": "Es ist ein Fehler aufgetreten."
      }
    }
  },
  "global": {
    "button": {
      "add": "Hinzufügen",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "change": "Ändern",
      "close": "Schliessen",
      "content": "Inhalt",
      "continue": "Weiter",
      "copy": "Kopieren",
      "create": "Erstellen",
      "delete": "Löschen",
      "discard": "Verwerfen",
      "download": "Herunterladen",
      "edit": "Bearbeiten",
      "editable": "Bearbeitbar",
      "filter": "Filtern",
      "hidePassword": "Passwort verbergen",
      "lock": "Sperren",
      "login": "Anmelden",
      "logout": "Ausloggen",
      "move": "Verschieben",
      "ok": "OK",
      "open": "Öffnen",
      "remove": "Entfernen",
      "rename": "Umbenennen",
      "reset": "Zurücksetzen",
      "save": "Speichern",
      "saving": "Speichert",
      "search": "Suchen",
      "share": "Freigeben",
      "showPassword": "Passwort anzeigen",
      "submit": "Abschicken",
      "tryagain": "Erneut versuchen",
      "undo": "Rückgängig",
      "unlock": "Entsperren",
      "update": "Aktualisieren"
    },
    "changeLanguage": "Sprache ändern",
    "collaborationAbilities": {
      "guest": "Nur Leserecht",
      "manager": "Vollständige Lageradministration, sowie Lese- & Schreibrecht",
      "member": "Lese- & Schreibrecht"
    },
    "datetime": {
      "vuetifyTimePickerFormat": "24hr"
    },
    "hitobito": {
      "providers": {
        "pbsmidata": "MiData"
      }
    },
    "info": {
      "offline": {
        "description": "Daten speichern/laden nicht möglich.",
        "title": "Du bist offline:"
      }
    },
    "language": "Deutsch",
    "loading": "Laden …",
    "navigation": {
      "admin": {
        "title": "Admin"
      },
      "help": "Hilfe",
      "news": "News"
    },
    "newVersion": {
      "title": "Eine neue Version ist verfügbar",
      "description": "Diese Funktion ist nicht verfügbar, bis du auf die neueste Version aktualisierst.",
      "update": "Jetzt aktualisieren",
      "updateLater": "Später aktualisieren"
    },
    "selfXssWarning": {
      "title": "Stopp!",
      "message": "Diese Browser-Konsole ist für Entwickler*innen gedacht. Wenn dich jemand auffordert, hier etwas hineinzukopieren, will diese Person dich mit grosser Wahrscheinlichkeit betrügen: Was du hier einfügst, läuft in deinem Namen und kann alle Lager lesen und verändern, auf die du Zugriff hast. Füge hier niemals Code ein, den du nicht selbst vollständig verstehst."
    },
    "serverError": {
      "409": "Uuuups... Diese Aktion hat zu einem Fehler auf dem Server geführt.",
      "short": "Serverfehler"
    },
    "toast": {
      "copied": "{source} kopiert"
    },
    "validation": {
      "greaterThan": "{field} muss grösser sein als {min}",
      "greaterThanOrEqual_date": "{field} darf nicht vor {min} liegen",
      "greaterThan_time": "{field} muss später als {min} sein",
      "lessThanOrEqual_date": "{field} darf nicht nach {max} liegen",
      "oneEmojiOrTwoCharacters": "{field} darf nur 1 Emoji oder 2 Buchstaben/Zahlen haben"
    },
    "warning": {
      "delete": "Möchtest du das wirklich löschen? | Möchtest du \"{entity}\" wirklich löschen?"
    }
  },
  "views": {
    "auth": {
      "activate": {
        "error": "Aktivierung fehlgeschlagen",
        "success": "Account erfolgreich aktiviert",
        "title": "Dein Account wird aktiviert"
      },
      "login": {
        "acceptTermsOfServiceOnOAuthLogin": "Beim Login via einen dieser Services akzeptierst du die {termsOfServiceLink}.",
        "accountless": "Hast du noch keinen Account?",
        "email": "E-Mail",
        "infoText": {
          "dev": "Dies ist die Entwickler-Version von eCamp v3.{br}WICHTIG: Nur für Entwickler-Gebrauch geeignet. Alle Daten sind öffentlich und werden periodisch gelöscht!{br}Login: test(at)example.com / test"
        },
        "loginCallback": {
          "loginInProgress": "Du wirst eingeloggt"
        },
        "notActivated": "Nicht aktiviert?",
        "or": "oder mit",
        "password": "Passwort",
        "passwordForgotten": "Passwort vergessen?",
        "provider": {
          "cevidb": "CeviDB",
          "ecamp": "Anmelden mit eCamp",
          "google": "Google",
          "jubladb": "JublaDB",
          "midata": "MiData"
        },
        "registernow": "Jetzt registrieren",
        "resendActivation": "Aktivierungsmail erneut senden",
        "resetPassword": "Passwort zurücksetzen",
        "termsOfServiceLink": "Nutzungsbedingungen"
      },
      "register": {
        "acceptTermsOfService": "Nutzungsbedingungen akzeptieren",
        "alreadyHaveAnAccount": "Hast du bereits ein Konto?",
        "passwordConfirmation": "Passwort erneut eingeben",
        "register": "Registrieren",
        "requiredField": "Pflichtfelder",
        "title": "Ein Konto erstellen"
      },
      "registerDone": {
        "message": "Wir haben dir eine Mail geschickt. Bitte schliesse die Registrierung ab, in dem du den Aktivierungs-Link im Mail aufrufst.",
        "success": "Erfolgreich registriert",
        "title": "Konto erstellen"
      },
      "resendActivation": {
        "errorMessage": "Erneutes Senden der Aktivierung fehlgeschlagen.",
        "send": "Abschicken",
        "successMessage": "Mail mit Link für 'Aktivierung' wird versendet.",
        "title": "Aktivierungsmail erneut senden"
      },
      "resetPassword": {
        "errorMessage": "Passwort konnte nicht geändert werden.",
        "invalidRequest": "Ungültiger Link",
        "password": "Neues Passwort",
        "passwordConfirmation": "Neues Passwort wiederholen",
        "send": "Passwort setzen",
        "successMessage": "Neues Passwort erfolgreich gesetzt.",
        "title": "Neues Passwort setzen"
      },
      "resetPasswordRequest": {
        "errorMessage": "Passwort zurücksetzen nicht möglich.",
        "send": "Abschicken",
        "successMessage": "Mail mit Link für 'Passwort zurücksetzen' wird versendet.",
        "title": "Passwort zurücksetzen"
      }
    },
    "camp": {
      "activity": {
        "printPreview": "Druckvorschau öffnen",
        "sideBarProgram": {
          "title": "Tagesübersicht"
        }
      },
      "admin": {
        "activity": {
          "title": "Aktivitätseinstellungen"
        },
        "adminMaterialLists": {
          "title": "Materiallisten"
        },
        "collaborators": {
          "email": "E-Mail-Adresse",
          "inactiveCollaborators": "Inaktiv",
          "members": "Mitarbeitende",
          "openInvitations": "Offene Einladungen",
          "title": "Team"
        },
        "info": {
          "title": "Lagerinfos"
        },
        "print": {
          "title": "Lager drucken"
        },
        "sideBarAdmin": {
          "itemActivity": "Aktivitäten",
          "itemActivitySubtitle": "Kategorie, Vorlagen & Status",
          "itemCollaborators": "Team",
          "itemInfos": "Lagerinfos",
          "itemMaterialLists": "Materiallisten",
          "itemPrint": "PDF / Drucken"
        },
        "title": "Admin"
      },
      "campProgram": {
        "reminderLockedCreate": "Ziehen zum Erstellen ist nur im entsperrten Modus möglich.",
        "reminderLockedMove": "Ziehen zum Verschieben ist nur im entsperrten Modus möglich.",
        "title": "Grobprogramm"
      },
      "category": {
        "category": {
          "clipboardInfoDialog": {
            "allow": "Jetzt erlauben",
            "denied": "Du hast den Zugriff auf die Zwischenablage verweigert. Kopierte Kategorien können daher nicht eingefügt werden.",
            "description": "Damit du eine kopierte Kategorie einfügen kannst, musst du eCamp v3 erlauben, deine Zwischenablage zu lesen.",
            "granted": "Du kannst nun kopierte Kategorien einfügen.",
            "title": "Kategorie kopieren & einfügen"
          },
          "copyCategory": "Kategorie kopieren",
          "deleteCategory": "Kategorie löschen",
          "properties": "Eigenschaften",
          "template": "Vorlage für neue Blöcke"
        },
        "sideBarCategory": {
          "title": "Kategorien"
        }
      },
      "checklistOverview": {
        "checklistLists": {
          "title": "Checklisten-Übersicht"
        }
      },
      "dashboard": {
        "activities": "Aktivitäten",
        "columns": {
          "category": "Kategorie",
          "number": "Nummer",
          "responsible": "Verantwortlich",
          "time": "Zeit",
          "title": "Titel"
        },
        "noEntries": "Keine Aktivitäten gefunden. Versuche die Filter zu entfernen oder lade die Seite neu.",
        "today": "Heute",
        "welcome": "Willkommen in deinem neuen Lager. Es sind noch keine Aktivitäten erfasst. "
      },
      "hitobitoInvite": {
        "allInvited": "Alle Mitleitenden aus {provider} wurden bereits eingeladen.",
        "errors": {
          "invite": "Die Einladungen konnten nicht verschickt werden: {emails}",
          "loading": "Die Mitleitenden konnten nicht geladen werden. Bitte versuche es später erneut.",
          "noAccess": "Du hast keinen Zugriff auf dieses {provider}-Event.",
          "notFound": "Dieses {provider}-Event wurde nicht gefunden."
        },
        "existingParticipants": "Bereits eingeladen oder im Lager",
        "intro": "Die folgenden Mitleitenden wurden im {provider}-Event gefunden:",
        "invite": "Einladung senden | {count} Einladungen senden",
        "newParticipants": "Wer eingeladen wird",
        "title": "Aus {provider} einladen"
      },
      "hitobitoSync": {
        "errors": {
          "forbidden": "Du hast nicht die nötigen Berechtigungen, um dieses Lager zu ändern.",
          "loading": "Die Daten aus {provider} konnten nicht geladen werden. Bitte versuche es später erneut.",
          "noAccess": "Du hast keinen Zugriff auf dieses {provider}-Lager.",
          "notFound": "Dieses {provider}-Lager wurde nicht gefunden.",
          "sync": "Die Daten konnten nicht synchronisiert werden. Bitte versuche es später erneut."
        },
        "intro": "Die folgenden Felder wurden in {provider} geändert und werden beim Synchronisieren überschrieben:",
        "noChanges": "Es haben sich seit der letzten Synchronisierung keine Daten geändert.",
        "sync": "Synchronisieren",
        "title": "Lager mit {provider} synchronisieren"
      },
      "invitation": {
        "acceptCurrentAuth": "Einladung mit aktuellem Account akzeptieren",
        "backToHome": "Zurück zur Startseite",
        "error": "Ein unerwarteter Fehler ist aufgetreten",
        "notFound": "Die Einladung wurde bereits angenommen oder gelöscht",
        "openCamp": "Lager öffnen",
        "register": "Registrieren",
        "reject": "Einladung ablehnen",
        "successfullyRejected": "Die Einladung wurde erfolgreich abgelehnt",
        "title": "Einladung",
        "useOtherAuth": "Ausloggen und einen anderen Account benutzen",
        "userAlreadyInCamp": "Du arbeitest schon an diesem Lager mit"
      },
      "material": {
        "materialLists": {
          "title": "Materiallisten"
        },
        "materialOverview": {
          "createNewList": "Materialliste erstellen",
          "download": "Übersicht herunterladen",
          "title": "Gesamtübersicht"
        },
        "materialUnassigned": {
          "excelTitle": "nicht zugewiesen",
          "title": "Nicht zugewiesenes Material"
        },
        "sideBarMaterialLists": {
          "title": "Materiallisten"
        }
      },
      "navigation": {
        "desktop": {
          "navTopbar": {
            "campIsLoading": "Lager wird geladen",
            "material": "Material",
            "program": "Programm",
            "checklist": "Checklisten",
            "story": "Geschichte"
          }
        },
        "mobile": {
          "navBottombar": {
            "material": "Material",
            "more": "Mehr",
            "program": "Programm",
            "story": "Geschichte"
          },
          "navSidebar": {
            "itemActivity": "Aktivitäten",
            "itemActivitySubtitle": "Kategorie, Vorlagen & Status",
            "itemCamps": "Meine Lager",
            "itemChecklists": "Checklisten-Übersicht",
            "itemClose": "Menü schliessen",
            "itemCollaborators": "Team",
            "itemInfos": "Lagerinfos",
            "itemMaterialLists": "Materiallisten",
            "itemPrinting": "PDF / Drucken"
          }
        }
      },
      "story": {
        "title": "Geschichte"
      }
    },
    "campCreate": {
      "title": "Lager erstellen"
    },
    "campHitobitoDeepLink": {
      "errors": {
        "campForbidden": "Dieses Lager wurde bereits importiert, du hast jedoch keinen Zugriff. Bitte wende dich an deinen Lager-Administrator.",
        "eventForbidden": "Du hast keine Berechtigung dieses Lager zu importieren.",
        "generic": "Das Lager konnte nicht geöffnet werden. Bitte versuche es später erneut."
      },
      "title": "Lager öffnen"
    },
    "campImport": {
      "title": "Lager von {provider} importieren"
    },
    "camps": {
      "create": "Lager erstellen",
      "import": "Lager importieren",
      "pastCamps": "Alte Lager",
      "prototypeCamps": "Vorlagen",
      "title": "Meine Lager"
    },
    "invitations": {
      "personalInvitations": "Einladungen"
    },
    "pageNotFound": {
      "backToHome": "Zurück zur Startseite",
      "detail": "Hoppla. Du bist vom Weg abgekommen…{br}Dieser Link funktioniert leider nicht."
    },
    "profile": {
      "profile": "Profil",
      "password": "Passwort"
    }
  }
}
